module.exports = __webpack_public_path__ + "media/images/blog-fake-image-0bb46e81756206b78411aec146c6f8da.png";